export default "__VITE_ASSET__0PmsmcW___"